import { c as _c } from "react/compiler-runtime";
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SearchBox, useHits, useSearchBox, useInstantSearch } from 'react-instantsearch';
import { connectInfiniteHits } from 'commons/react-instantsearch-dom-wrappers';
import InfiniteScroll from 'react-infinite-scroll-component';
import loadable from '@loadable/component';
import constructFabricUrl from 'commons/constructFabricUrl';
import addDomainToPath from 'commons/addDomainToPath';
import { COLOR_CODES_FABRIC } from 'commons/constants';
import JBImage from 'components/essentials/JBImage';
import IconPlus from 'components/icons/iconPlus';
import imageUrls from 'commons/image-urls.json';
import useScreen from 'hooks/useScreen';
import MasonryPhotoCard from '../photo-card/PhotoCard';
const Masonry = loadable(() => import('../JoybirdMasonry'), {
  ssr: false
});
let MATERIALS_DATA = null;
export const EXCLUDED_FILTER_PILLS = ['color', 'material', 'room'];
export const FACET_FILTER_VALUES = {
  room: 'photo_room:',
  material: 'products.material:',
  color: 'products.option_color:',
  upholstery: 'products.upholstery:',
  product_id: 'products.product_id:',
  option_value: 'products.upholstery:'
};
export const FACET_FILTER_VALUES_SEARCH = {
  room: 'photo_room:',
  material: 'material:',
  option_color: 'option_color:',
  type: 'type:',
  product_material: 'option_name:'
};
const imgixDomains = imageUrls.inspireImgixDomains;
export const transformInspirationImageUrl = imageUrl => {
  const url = imageUrl || '';
  const domain = imgixDomains[url.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0) % imgixDomains.length];
  let path = url;
  if (url.startsWith('https://pstatic.joybird.com/')) {
    path = url.replace('https://pstatic.joybird.com/', domain);
  } else if (url.startsWith('https://inspire.imgix.net/')) {
    path = url.replace('https://inspire.imgix.net/', domain);
  } else if (url.startsWith('/ds_quiz/')) {
    path = addDomainToPath(url.slice(1));
  }
  const split = path.split('/');
  const imgName = split.pop().replace('main_', '');
  split.push(imgName);
  return split.join('/');
};
export const InspirationSearchBox = t0 => {
  const $ = _c(10);
  const {
    defaultRefinement,
    onProductClicked,
    resetProductSearch
  } = t0;
  const {
    isMobile
  } = useScreen();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("mx-5 my-0 flex flex-row items-stretch relative box-border min-[1440px]:mx-[3.333vw] min-[1440px]:my-0 p-0 m-0", "[&_.ais-SearchBox-form_.ais-SearchBox-input]:text-[.8rem] [&_.ais-SearchBox-form_.ais-SearchBox-input]:h-[44px] [&_.ais-SearchBox-form_.ais-SearchBox-input]:text-gray-dark [&_.ais-SearchBox-form_.ais-SearchBox-input]:block [&_.ais-SearchBox-form_.ais-SearchBox-input]:border [&_.ais-SearchBox-form_.ais-SearchBox-input]:border-solid [&_.ais-SearchBox-form_.ais-SearchBox-input]:border-transparent [&_.ais-SearchBox-form_.ais-SearchBox-input]:border-b-gray-light3 [&_.ais-SearchBox-form_.ais-SearchBox-input]:pt-0 [&_.ais-SearchBox-form_.ais-SearchBox-input]:pr-0 [&_.ais-SearchBox-form_.ais-SearchBox-input]:pb-0", "[&_.ais-SearchBox-form_.ais-SearchBox-input]:bg-search [&_.ais-SearchBox-form_.ais-SearchBox-input]:bg-no-repeat [&_.ais-SearchBox-form_.ais-SearchBox-input]:[background-position:0_50%]", "[&_.ais-SearchBox-form_.ais-SearchBox-input]:!pl-9 [&_.ais-SearchBox-form_.ais-SearchBox-input]:w-[310px] [&_.ais-SearchBox-form_.ais-SearchBox-input]:leading-[32px] [&_.ais-SearchBox-form_.ais-SearchBox-input]:text-lg", "[&_.ais-SearchBox-form_.ais-SearchBox-input::placeholder]:text-lg [&_.ais-SearchBox-form_.ais-SearchBox-input::placeholder]:text-left", "max-[767px]:[&_.ais-SearchBox-form_.ais-SearchBox-input]:border-b-0 max-[767px]:[&_.ais-SearchBox-form_.ais-SearchBox-input]:w-full", "max-[767px]:[.ais-SearchBox-input.hasValue_~_&]:!flex max-[767px]:[.ais-SearchBox-input.hasValue_~_&_svg]:fill-gray max-[767px]:[.ais-SearchBox-input.hasValue_~_&_svg]:w-3 max-[767px]:[.ais-SearchBox-input.hasValue_~_&_svg]:h-3 max-[767px]:[.ais-SearchBox-input.hasValue_~_&_.ais-SearchBox-reset]:!block md:[&_.ais-SearchBox-reset]:!hidden md:[&_.ais-SearchBox-submit]:!hidden md:[&_.ais-SearchBox-reset]:absolute md:[&_.ais-SearchBox-reset]:top-[40%] md:[&_.ais-SearchBox-reset]:right-[10px]");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      onInput: _temp
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onProductClicked || $[4] !== resetProductSearch) {
    t4 = async event_0 => {
      const target = event_0.currentTarget;
      onProductClicked("");
      resetProductSearch();
      const form = target?.closest(".ais-SearchBox-form");
      form?.querySelector(".ais-SearchBox-input")?.classList.remove("hasValue");
    };
    $[3] = onProductClicked;
    $[4] = resetProductSearch;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isMobile ? "Search" : "Search for products or materials";
  let t6;
  if ($[6] !== defaultRefinement || $[7] !== t4 || $[8] !== t5) {
    t6 = <div className="[&_i]:w-[18px] [&_i]:h-[18px] [&_i]:text-[18px] [&_i]:block [&_i]:absolute [&_i]:top-1/2 [&_i]:mt-[-9px] [&_i]:right-10 [&_i]:cursor-pointer [&_i]:[border-right:1px_solid_#dfe0e1] bg-gray-light8 min-h-[46px] ![background-color:initial] !text-gray-light1 border-gray-light5 border !border-l-0 !border-r-0 !border-t-0 md:!border-b-0 !p-0 [&_input]:text-base [&_input]:font-bold [&_input]:!text-gray-light2 [&_input]:!p-0"><div className={t1}><div className="inline-flex w-full"><SearchBox translations={t2} defaultRefinement={defaultRefinement} inputProps={t3} onReset={t4} placeholder={t5} /></div></div></div>;
    $[6] = defaultRefinement;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
InspirationSearchBox.propTypes = {
  defaultRefinement: PropTypes.string,
  onProductClicked: PropTypes.func,
  resetProductSearch: PropTypes.func
};
const updateMaterialData = fabricsData => {
  const finalData = fabricsData.reduce((acc, currentVal) => {
    const firstChar = currentVal.option_value.toLowerCase().charAt(0);
    if (acc[firstChar]) {
      acc[firstChar].push(currentVal);
    } else {
      acc[firstChar] = [currentVal];
    }
    return acc;
  }, {});
  return finalData;
};
const returnTopThreeMatchingMaterials = query => {
  if (!query) return [];
  const lowercaseQuery = query.toLowerCase();
  const results = MATERIALS_DATA && MATERIALS_DATA[lowercaseQuery.charAt(0)] ? MATERIALS_DATA[lowercaseQuery.charAt(0)].filter(val => val.option_value.toLowerCase().includes(lowercaseQuery)) : [];
  return results.splice(0, 3) || [];
};
const InspirationSearchOptionsWithHooks = ({
  fabricsData,
  onSearchUpdate,
  onMaterialOptionChange,
  onProductClicked,
  isProductIdFiltered,
  isMaterialOptionFiltered
}) => {
  const {
    query
  } = useSearchBox();
  const {
    hits
  } = useHits();
  const {
    setIndexUiState
  } = useInstantSearch();
  if (!MATERIALS_DATA && !!fabricsData) MATERIALS_DATA = updateMaterialData(fabricsData);
  if (query?.length < 1 || !hits?.length) {
    return null;
  }
  if (isProductIdFiltered?.isFiltered && query === isProductIdFiltered?.productName || isMaterialOptionFiltered && query === isMaterialOptionFiltered) {
    return null;
  }
  const fabricMatches = returnTopThreeMatchingMaterials(query);
  const noFabricResults = hits.filter(product => product.type !== 'Fabric');
  return <div className="absolute bg-white z-[1888] w-full top-[46px] left-0 px-2 py-6 border border-solid border-gray-light7 rounded-lg max-h-[457px] overflow-auto">
      {fabricMatches.length ? <div className="inspiration-search__list--section">
          <div className="text-xs font-bold text-[#74777a] mb-2 max-[767px]:text-base max-[767px]:font-bold max-[767px]:text-gray">
            Materials
          </div>
          {fabricMatches.map(matches => <button type="button" key={matches.option_value_id} className="text-sm rounded-sm w-full flex flex-row items-center justify-start px-0 py-4 cursor-pointer border-0 [background:none] font-bold hover:bg-gray-light8 focus-visible:outline-offset-[-4px]" onClick={() => {
        const value = matches.option_value;
        setIndexUiState(prev => ({
          ...prev,
          query: value
        }));
        onSearchUpdate({
          query: value
        });
        onMaterialOptionChange(value);
      }}>
              <div className="pl-4 w-[4.5rem] [&_img]:w-full">
                <JBImage src={constructFabricUrl(matches.option_value).transparent_config_image} width={200} alt={matches.option_value} />
              </div>
              <div className="pr-4 text-gray-light1 font-normal ml-6">
                {matches.option_value}
              </div>
            </button>)}
        </div> : null}

      {query.length > 0 && hits.length ? <div className="inspiration-search__list--section">
          <div className="text-xs font-bold text-[#74777a] mb-2 max-[767px]:text-base max-[767px]:font-bold max-[767px]:text-gray">
            Products
          </div>
          {noFabricResults.map(product_0 => <button type="button" key={product_0.product_id} className="text-sm rounded-sm w-full flex flex-row items-center justify-start px-0 py-4 cursor-pointer border-0 [background:none] font-bold hover:bg-gray-light8 focus-visible:outline-offset-[-4px]" onClick={() => {
        const productName = product_0.name;
        setIndexUiState(prev_0 => ({
          ...prev_0,
          query: productName
        }));
        onSearchUpdate({
          query: productName
        });
        onProductClicked(product_0.product_id, productName);
      }}>
              <div className="pl-4 w-[4.5rem] [&_img]:w-full">
                <JBImage src={addDomainToPath(product_0.small_img)} width={200} alt={product_0.name} />
              </div>
              <div className="pr-4 text-[#585858] font-normal ml-6">
                {product_0.name}
              </div>
            </button>)}
        </div> : null}
    </div>;
};
InspirationSearchOptionsWithHooks.propTypes = {
  fabricsData: PropTypes.array,
  onSearchUpdate: PropTypes.func.isRequired,
  onMaterialOptionChange: PropTypes.func.isRequired,
  onProductClicked: PropTypes.func.isRequired,
  isProductIdFiltered: PropTypes.shape({
    isFiltered: PropTypes.bool,
    productName: PropTypes.string
  }).isRequired,
  isMaterialOptionFiltered: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export const InspirationSearchOptions = InspirationSearchOptionsWithHooks;
export const PhotoCardsResult = t0 => {
  const $ = _c(53);
  let hasFilters;
  let hasMore;
  let hits;
  let mobileItemsPerRow;
  let otherProps;
  let refine;
  let selectedGridItem;
  let showOnTop;
  let t1;
  let t2;
  let t3;
  let t4;
  let updateSelectedGridItem;
  if ($[0] !== t0) {
    const {
      hasFilters: t5,
      hasMore: t6,
      hits: t7,
      loading: t8,
      mobileItemsPerRow: t9,
      multiSelectedGridItem: t10,
      refine: t11,
      selectedGridItem: t12,
      showOnTop: t13,
      updateHits,
      updateSelectedGridItem: t14,
      variant: t15,
      isSidebarOpen: t16,
      ...t17
    } = t0;
    hasFilters = t5;
    hasMore = t6;
    hits = t7;
    t1 = t8;
    mobileItemsPerRow = t9;
    t2 = t10;
    refine = t11;
    selectedGridItem = t12;
    showOnTop = t13;
    updateSelectedGridItem = t14;
    t3 = t15;
    t4 = t16;
    otherProps = t17;
    $[0] = t0;
    $[1] = hasFilters;
    $[2] = hasMore;
    $[3] = hits;
    $[4] = mobileItemsPerRow;
    $[5] = otherProps;
    $[6] = refine;
    $[7] = selectedGridItem;
    $[8] = showOnTop;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = updateSelectedGridItem;
  } else {
    hasFilters = $[1];
    hasMore = $[2];
    hits = $[3];
    mobileItemsPerRow = $[4];
    otherProps = $[5];
    refine = $[6];
    selectedGridItem = $[7];
    showOnTop = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    updateSelectedGridItem = $[13];
  }
  const loading = t1 === undefined ? false : t1;
  const multiSelectedGridItem = t2 === undefined ? null : t2;
  const variant = t3 === undefined ? "" : t3;
  const isSidebarOpen = t4 === undefined ? false : t4;
  const [activeId, setActiveId] = useState(null);
  const {
    isMobile,
    windowWidth
  } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? "2800px" : "2200px";
  let t5;
  if ($[14] !== isMobile) {
    t5 = isMobile ? {
      height: "initial",
      overflow: "initial"
    } : {};
    $[14] = isMobile;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const mobileScrollStyle = t5;
  if (!hits) {
    return null;
  }
  if (hasFilters && hits.length === 0) {
    if (loading) {
      let t6;
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <div className="w-full flex items-center justify-center min-h-[20vh]"><div className="text-center"><div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-2" role="status" aria-label="Loading" /></div></div>;
        $[16] = t6;
      } else {
        t6 = $[16];
      }
      return t6;
    }
    let t6;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="w-full flex items-center justify-center min-h-[20vh]">No matches found!</div>;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    return t6;
  }
  let t6;
  if ($[18] !== hits) {
    t6 = hits && hits.length ? hits.map(_temp2) : hits;
    $[18] = hits;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const formattedHits = t6;
  let t7;
  if ($[20] !== activeId || $[21] !== formattedHits || $[22] !== isMobile || $[23] !== mobileItemsPerRow || $[24] !== multiSelectedGridItem || $[25] !== otherProps || $[26] !== selectedGridItem || $[27] !== showOnTop || $[28] !== updateSelectedGridItem) {
    t7 = formattedHits.map(photo => {
      const finalSelGridItem = multiSelectedGridItem && multiSelectedGridItem[photo.photo_id] ? multiSelectedGridItem[photo.photo_id] : selectedGridItem;
      return <MasonryPhotoCard {...otherProps} active={activeId === photo.photo_id} hits={formattedHits} isMobile={isMobile} key={photo.photo_id} mobileItemsPerRow={mobileItemsPerRow} noScrollToView={otherProps.noScrollToView ?? true} photo={photo} selectedGridItem={finalSelGridItem} setActiveId={setActiveId} showOnTop={showOnTop} updateSelectedGridItem={updateSelectedGridItem} />;
    });
    $[20] = activeId;
    $[21] = formattedHits;
    $[22] = isMobile;
    $[23] = mobileItemsPerRow;
    $[24] = multiSelectedGridItem;
    $[25] = otherProps;
    $[26] = selectedGridItem;
    $[27] = showOnTop;
    $[28] = updateSelectedGridItem;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  const photoCardsList = t7;
  const t8 = photoCardsList.length;
  const t9 = otherProps.searchMore ? otherProps.searchMore : refine;
  const t10 = otherProps.scrollableTarget;
  const t11 = variant === "InspirationPage";
  let t12;
  if ($[30] !== t11) {
    t12 = classNames({
      "my-0 -mx-4": t11
    });
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== isMobile || $[33] !== isSidebarOpen || $[34] !== mobileItemsPerRow || $[35] !== photoCardsList || $[36] !== variant) {
    t13 = isMobile ? <div className={classNames("customer-photos-mobile-grid grid gap-[2px] grid-cols-[repeat(auto-fill,minmax(30%,1fr))] w-full", {
      "max-[767px]:!grid-cols-[repeat(auto-fill,minmax(45%,1fr))]": variant === "customer-photos-grid" || mobileItemsPerRow === 2,
      "max-[767px]:!grid-cols-[repeat(auto-fill,minmax(95%,1fr))]": mobileItemsPerRow === 1
    })}>{photoCardsList}</div> : <div className="w-full [&>div]:overflow-hidden"><Masonry photoCardsList={photoCardsList} isSidebarOpen={isSidebarOpen} /></div>;
    $[32] = isMobile;
    $[33] = isSidebarOpen;
    $[34] = mobileItemsPerRow;
    $[35] = photoCardsList;
    $[36] = variant;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== hasMore || $[39] !== infiniteScrollThreshold || $[40] !== mobileScrollStyle || $[41] !== otherProps.scrollableTarget || $[42] !== photoCardsList.length || $[43] !== t12 || $[44] !== t13 || $[45] !== t9) {
    t14 = <InfiniteScroll dataLength={t8} next={t9} hasMore={hasMore} scrollThreshold={infiniteScrollThreshold} scrollableTarget={t10} style={mobileScrollStyle} className={t12}>{t13}</InfiniteScroll>;
    $[38] = hasMore;
    $[39] = infiniteScrollThreshold;
    $[40] = mobileScrollStyle;
    $[41] = otherProps.scrollableTarget;
    $[42] = photoCardsList.length;
    $[43] = t12;
    $[44] = t13;
    $[45] = t9;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== hasMore || $[48] !== refine) {
    t15 = hasMore ? <div className="products-grid__load-more"><button type="button" className="text-base [background:none] border-0 text-gray-light1 mt-4 p-2 hover:cursor-pointer hover:text-gray-dark focus-visible:text-gray-dark" onClick={refine}>Load more</button></div> : null;
    $[47] = hasMore;
    $[48] = refine;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] !== t14 || $[51] !== t15) {
    t16 = <>{t14}{t15}</>;
    $[50] = t14;
    $[51] = t15;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  return t16;
};
PhotoCardsResult.propTypes = {
  hasFilters: PropTypes.bool,
  hasMore: PropTypes.bool,
  hits: PropTypes.array,
  loading: PropTypes.bool,
  mobileItemsPerRow: PropTypes.number,
  multiSelectedGridItem: PropTypes.object,
  noScrollToView: PropTypes.bool,
  refine: PropTypes.func,
  scrollableTarget: PropTypes.string,
  selectedGridItem: PropTypes.object,
  showOnTop: PropTypes.bool,
  updateHits: PropTypes.func,
  updateSelectedGridItem: PropTypes.func,
  variant: PropTypes.string
};
export const PhotoCardsResultSearch = connectInfiniteHits(PhotoCardsResult);
export const removeFilterValue = (facetFilters, type, value, forIndex) => {
  const filterArray = facetFilters.split(',');
  const finalFacetVals = forIndex && forIndex === 'search' ? FACET_FILTER_VALUES_SEARCH : FACET_FILTER_VALUES;
  if (value) {
    return filterArray.filter(filter => filter !== `${finalFacetVals[type]}${value}` && filter !== '').toString();
  }
  return filterArray.filter(filter => !filter.includes(`${finalFacetVals[type]}`) && filter !== '').toString();
};
const toTitleCase = text => `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
const getHexColor = color => COLOR_CODES_FABRIC.filter(obj => obj[color])[0][color];
export const SelectedFilter = t0 => {
  const $ = _c(17);
  const {
    filterName,
    onDeselect,
    name,
    type
  } = t0;
  let t1;
  if ($[0] !== filterName || $[1] !== name || $[2] !== onDeselect || $[3] !== type) {
    t1 = () => {
      if (type && type === "search") {
        onDeselect(name, filterName);
      } else {
        onDeselect(filterName, name);
      }
    };
    $[0] = filterName;
    $[1] = name;
    $[2] = onDeselect;
    $[3] = type;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== filterName || $[6] !== name) {
    t2 = name === "color" && <div className="h-[15px] w-[15px] rounded-lg mx-[5px]" style={{
      background: getHexColor(filterName)
    }} />;
    $[5] = filterName;
    $[6] = name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== filterName) {
    t3 = toTitleCase(filterName);
    $[8] = filterName;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="ml-1 rotate-45"><IconPlus /></div>;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3) {
    t5 = <div className="flex items-center">{t2}{t3}{t4}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t1 || $[15] !== t5) {
    t6 = <button type="button" className="text-gray flex flex-row justify-center my-1 mr-3 py-[0.4rem] px-2 font-normal b-0 bg-gray-light7 rounded focus-visible:-outline-offset-1 first:ml-0 hover:bg-gray-light9 hover:cursor-pointer" onClick={t1}>{t5}</button>;
    $[14] = t1;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
SelectedFilter.propTypes = {
  filterName: PropTypes.string,
  onDeselect: PropTypes.func,
  name: PropTypes.string,
  type: PropTypes.string
};
function _temp(event) {
  const value = event?.target?.value ?? "";
  const input = event?.target;
  if (input) {
    if (value.length > 0) {
      input.classList.add("hasValue");
    } else {
      input.classList.remove("hasValue");
    }
  }
}
function _temp2(hit) {
  return {
    ...hit,
    image_link: transformInspirationImageUrl(hit.image_link)
  };
}